<template>
  <nav id="navbar" class="navbar fixed-top">
<div class="container pt-0 pb-0 d-flex justify-content-between align-items-center">
 
  <div>
      <h4>Magdalena Bygg och Måleri</h4>
     <img src="../assets/logo1.jpg" />
 </div>

 <div>
     <ul> 
     	<li><a href="#">Startsida</a> </li>
     	<li><a href="#main">Om oss</a> </li>
     	<li><a href="#main1">Tjänster</a> </li>
      <li><a href="#main3">Referenser</a> </li>

     	<li><a href="#main2"> Kontakt</a></li>
     </ul>
 </div>

   
   </div>
</nav>
</template>

<script>
export default {

}
</script>

<style>
#navbar{background-color:royalblue;
color:#fff;top:49px;}

#navbar ul{padding:0; list-style:none;}

#navbar li{display:inline;}

#navbar a{ color:#fff; 
text-decoration: none;
font-size:18px; 
padding-right: 15px;
text-align: right; }



</style>